import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import SessionSectionHeader from './session-section-header'
import UpcomingSessions from './upcoming'
import PastSessions from './past'
import { useStyles } from './styles'

const SessionsSection = ({ studentId, onBookClick }) => {
  const classes = useStyles()
  const [selectedTab, setSelectedTab] = useState('upcoming')

  return (
    <Box className={classes.sessionsSection}>
      <SessionSectionHeader
        title="Sessions"
        className={classes.sessionsSectionHeader}
      />
      <Tabs
        className={classes.sessionTabs}
        value={selectedTab}
        onChange={(_, value) => setSelectedTab(value)}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab className={classes.sessionTab} label="Upcoming" value="upcoming" />
        <Tab className={classes.sessionTab} label="Past" value="past" />
      </Tabs>
      <Box className={classes.sessionTabPanel}>
        {selectedTab === 'upcoming' ? (
          <UpcomingSessions
            studentId={studentId}
            onBookClick={onBookClick}
            embedded
          />
        ) : (
          <PastSessions studentId={studentId} embedded />
        )}
      </Box>
    </Box>
  )
}

export default SessionsSection
